import { graphql } from "relay-runtime"

export const deMedicationFragment = graphql`
  fragment deMedicationFragment on de_Medication {
    __typename
    id
    refuseSubstitutes
    numberOfPackages
    endDate
    eveningDosage
    internalNotes
    isPrescriptionRequired
    morningDosage
    name
    nightDosage
    noonDosage
    patientId
    pharmaceuticalCentralNumber
    startDate
    unit
    usageInstructions
    composition
    type
    updatedAt
    updatedBy
    createdAt
    createdBy
    isPermanentPrescription
  }
`

export const deMedicationFragmentInline = graphql`
  fragment deMedicationFragmentInline on de_Medication @inline {
    __typename
    id
    refuseSubstitutes
    numberOfPackages
    endDate
    eveningDosage
    internalNotes
    isPrescriptionRequired
    morningDosage
    name
    nightDosage
    noonDosage
    patientId
    pharmaceuticalCentralNumber
    startDate
    unit
    usageInstructions
    composition
    type
    updatedAt
    updatedBy
    createdAt
    createdBy
    isPermanentPrescription
  }
`
